<div
  class="data-widget {{ color() }}"
  [class.selected]="selected()"
  [class.clickable]="clickable()"
  [style.padding.px]="isNumber(padding()) ? padding() : undefined"
  [style.padding]="isNumber() ? undefined : padding()"
>
  <div class="main-column" [style.gap.px]="gap()">
    @if (supheading(); as supheading) {
      <div class="supheading-container">
        <span class="f-body-s">{{ supheading | translate }}</span>

        <ng-content select="[supheadingContent]"></ng-content>
      </div>
    }

    <div class="heading f-heading-m">
      @if (headingIcon(); as icon) {
        <onyx-icon
          class="{{ icon.color }}"
          [name]="icon.name"
          [size]="icon.size"
          [frame]="icon.frame"
          [onyxTooltip]="icon.tooltip"
        ></onyx-icon>
      }

      <ng-content select="[heading]"></ng-content>

      @if (showHeadingAddon()) {
        <span class="f-body-m f-medium">
          <ng-content select="[headingAddon]"></ng-content>
        </span>
      }
    </div>

    <div class="heading f-heading-m">
      <ng-content select="[secondaryHeading]"></ng-content>
    </div>

    <span class="f-body-s">
      <ng-content select="[description]"></ng-content>
    </span>

    @if (showDivider()) {
      <div class="divider"></div>
    }

    <span style="display: contents">
      <ng-content></ng-content>
    </span>
  </div>

  <ng-content select="[columns]"></ng-content>
</div>
